<template>
  <div id="setting-receiver" class="col-12" :class="isDisabledClass" @click.self="isShow(false)">
    <div class="user-selector">
      <div class="setting-owner" v-if="selectUserRoles">
        <p class="my-2">
          <strong>ต้องการส่งข่าวนี้ถึง</strong>
        </p>
        <label 
          class="select-input">
          เจ้าของ
          <input
            type="checkbox"
            value="owner"
            name="userRole"
            :disabled="!canUpdateContent"
            v-model="selectUserRoles"
            v-validate="'required'"
            @change="setUserRoles"
          />
          <span
            class="checkmark checkbox"
            :class="{ error: errors.has('userRole') }"
          ></span>
        </label>
        <label 
          class="select-input">
          ผู้อยู่อาศัย
          <input
            type="checkbox"
            value="resident"
            v-model="selectUserRoles"
            name="userRole"
            :disabled="!canUpdateContent"
            v-validate="'required'"
            @change="setUserRoles"
          />
          <span
            class="checkmark checkbox"
            :class="{ error: errors.has('userRole') }"
          ></span>
        </label>
        <label 
          class="select-input">
          ผู้เช่า
          <input
            type="checkbox"
            value="renter"
            v-model="selectUserRoles"
            name="userRole"
            :disabled="!canUpdateContent"
            v-validate="'required'"
            @change="setUserRoles"
          />
          <span
            class="checkmark checkbox"
            :class="{ error: errors.has('userRole') }"
          ></span>
        </label>
        <label 
          class="select-input">
          ผู้ทำสัญญา
          <input
            type="checkbox"
            value="contract"
            v-model="selectUserRoles"
            name="userRole"
            :disabled="!canUpdateContent"
            v-validate="'required'"
            @change="setUserRoles"
          />
          <span
            class="checkmark checkbox"
            :class="{ error: errors.has('userRole') }"
          ></span>
        </label>
        <label 
          class="select-input">
          ผู้จอง
          <input
            type="checkbox"
            value="booking"
            v-model="selectUserRoles"
            name="userRole"
            :disabled="!canUpdateContent"
            v-validate="'required'"
            @change="setUserRoles"
          />
          <span
            class="checkmark checkbox"
            :class="{ error: errors.has('userRole') }"
          ></span>
        </label>
        <label 
          class="select-input">
          คนทั่วไป
          <input
            type="checkbox"
            value="visitor"
            v-model="selectUserRoles"
            name="userRole"
            :disabled="!canUpdateContent"
            v-validate="'required'"
            @change="setUserRoles"
          />
          <span
            class="checkmark checkbox"
            :class="{ error: errors.has('userRole') }"
          ></span>
        </label>
      </div>
    </div>
    <div>
      <label 
        class="select-input">
        เฉพาะพนักงาน SC
        <input
          type="checkbox"
          value="35854"
          v-model="selectSCOnly"
          name="checkSCOnly"
          :disabled="!canUpdateContent"
          @change="setSCHomeOnly"
        />
        <span
          class="checkmark checkbox"
          :class="{ error: errors.has('userRole') }"
        ></span>
      </label>
    </div>
    <div class="project-selector" v-if="projectSelectRules && canUpdateContent">
      <input
        type="hidden"
        name="projects"
        v-model="selectProjects.length"
        v-validate="'required|min_value:1'"
      />
      <p class="my-2">
        <strong>เลือกโครงการที่จะประกาศ</strong>
      </p>
      <div
        class="project-box row m-0 p-0"
        v-if="projects && selectProjects"
        :class="{ error: errors.has('projects') }"
      >
        <div class="col-7 p-0 list-height">
          <div class="head row p-0 m-0">
            <div class="project-search input-group col-7 p-2">
              <div class="input-group-prepend">
                <span class="input-group-text" id="basic-addon1"
                  ><i class="fas fa-search"></i
                ></span>
              </div>
              <input
                type="text"
                class="form-control"
                :placeholder="$t('feature.article.setting.project_search')"
                v-model="searchProject"
                @keyup.enter="getProjects()"
              />
            </div>
            <div class="filter col-5">
              <div class="dropdown">
                <button
                  class="sc-btn dropdown-toggle"
                  type="button"
                  id="dropdown-project-type"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  {{ filterProjectType.name || "ทุกประเภท" }}
                </button>
                <ul
                  class="dropdown-menu"
                  aria-labelledby="dropdown-project-type"
                >
                  <li
                    class="dropdown-item"
                    v-for="(type, index) in projectTypes"
                    :key="index"
                    @click="filterProjectByProjectType(type)"
                  >
                    {{ type.name }}
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="projects col">
            <div class="all pointer" @click="selectProjectAll()">
              {{ $t("label.select_all") }}
            </div>
            <div
              class="group-wrapper"
              v-for="(group, groupName) in projectGroups"
              :key="groupName"
            >
              <div class="project-group" @click="selectProjectGroup(groupName)">
                {{ groupName }} - {{ group.length }} โครงการ
              </div>
              <div
                class="project"
                v-for="project in group"
                :key="project.projectId"
                @click="selectProject(project)"
              >
                {{ project.projectCode }} - {{ project.projectName }}
              </div>
            </div>
          </div>
        </div>
        <div class="results-panel col-5 p-0 list-height" v-if="selectProjects">
          <div class="media projects-head">
            <div class="projects-counter media-body">
              เลือกแล้ว {{ selectProjects.length }} โครงการ
            </div>
            <div
              class="projects-remove mt-1 pointer"
              v-if="canUpdateContent"
              @click="removeProjectAll()"
            >
              ลบทั้งหมด
            </div>
          </div>
          <div class="project-select col px-0">
            <div
              class="media tag"
              v-for="(selectProject, index) in selectProjects"
              :key="selectProject.projectId"
            >
              <div class="media-body">
                {{ selectProject.projectCode }} -
                {{ selectProject.projectName }}
              </div>
              <div
                class="ml-3"
                v-if="canUpdateContent"
                @click="removeProject(index)"
              >
                <img src="/static/icons/close.svg" alt="remove" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="project-picked" v-if="!canUpdateContent">
      <p class="my-2">
        <strong>โครงการที่เลือกประกาศ</strong>
      </p>
      <div class="project-box row m-0 p-0" v-if="projects && selectProjects">
        <div
          class="results-panel no-left-border col-12 p-0"
          v-if="selectProjects"
        >
          <div class="media projects-head">
            <div class="projects-counter media-body">
              เลือกทั้งหมด {{ selectProjects.length }} โครงการ
            </div>
          </div>
          <div class="project-select col px-0">
            <div
              class="media tag"
              v-for="selectProject in selectProjects"
              :key="selectProject.projectId"
            >
              <div class="media-body">
                {{ selectProject.projectCode }} -
                {{ selectProject.projectName }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import "bootstrap";
import { getCookie, Auth } from "@/lib/cookie";

export default {
  props: ["dataSettings", "approvedAt", "canUpdateContent", "isThaiLanguage"],
  data() {
    return {
      tabActive: "projects",
      filterBrand: "",
      filterProjectType: "",
      projects: [],
      projectGroups: {},
      projectTypes: [
        { key: "", name: "ทุกประเภท" },
        { key: "H", name: "แนวสูง" },
        { key: "L", name: "แนวราบ" },
      ],
      searchProject: "",
      selectUserRoles: [],
      selectProjects: [],
      selectHomes: "",
      homeType: 1,
      projectType: 1,
      selectSCOnly: false,
    };
  },
  computed: {
    projectSelectRules() {
      return (
        this.selectUserRoles.includes("owner") ||
        this.selectUserRoles.includes("resident") ||
        this.selectUserRoles.includes("renter") ||
        this.selectUserRoles.includes("contract") ||
        this.selectUserRoles.includes("booking")
      );
    },
    isDisabledClass() {
      return {
        "disable-content": !this.isThaiLanguage,
      };
    },
  },
  methods: {
    isShow() {
      this.$emit("isshow", false);
    },
    setTab(tab) {
      this.tabActive = tab;
    },
    getProjects() {
      const vm = this;
      const data = { searchText: vm.searchProject };

      if (vm.filterProjectType && vm.filterProjectType.key) {
        data.type = vm.filterProjectType.key;
      }

      axios
        .get(`${process.env.HOST}/api/admin/projects`, {
          params: data,
          headers: {
            Authorization: `Bearer ${getCookie(Auth.AccessToken)}`,
          },
        })
        .then((res) => {
          vm.projects = res.data;
          vm.projectGroups = {};
          vm.projects.forEach((project) => {
            if (!vm.projectGroups[project.projectGroup]) {
              vm.projectGroups[project.projectGroup] = [project];
            } else {
              vm.projectGroups[project.projectGroup].push(project);
            }
          });
        });
    },
    selectProjectAll() {
      this.selectProjects = this.projects;
      this.$emit("setProjects", this.projects);
    },
    selectProjectGroup(name) {
      this.projectGroups[name].forEach((project) => {
        if (!this.checkProjectDupicate(project)) {
          this.selectProjects = this.selectProjects.concat(project);
        }
      });
      this.$emit("setProjects", this.selectProjects);
    },
    removeProjectAll() {
      this.selectProjects = [];
      this.$emit("setProjects", this.selectProjects);
    },
    selectProject(project) {
      if (!this.checkProjectDupicate(project)) {
        this.selectProjects = this.selectProjects.concat(project);
        this.$emit("setProjects", this.selectProjects);
      }
    },
    removeProject(index) {
      this.selectProjects.splice(index, 1);
      this.$emit("setProjects", this.selectProjects);
    },
    checkProjectDupicate(project) {
      return this.selectProjects.some((pro) => {
        if (pro.projectId === project.projectId) {
          return true;
        }
        return false;
      });
    },
    filterProjectByProjectType(type) {
      this.filterProjectType = type;
      this.getProjects();
    },
    setUserRoles() {
      if (this.canUpdateContent) {
        this.$emit("setUserRoles", this.selectUserRoles);
      }
    },
    setSCHomeOnly() {
      if (this.canUpdateContent) {
        if (this.selectSCOnly) {
          this.selectHomes = "35854";
        } else {
          this.selectHomes = null;
        }
        this.$emit("setHomes", this.selectHomes);
      }
    },
    async validate() {
      const result = await this.$validator.validate();
      this.$emit("validate", result);
      return result;
    },
  },
  watch: {
    "dataSettings.selectProjects": function mapSelectProjects() {
      this.selectProjects = this.dataSettings.selectProjects;
    },
    "dataSettings.owner": function mapUserRoles() {
      this.selectUserRoles = this.dataSettings.owner;
    },
    "dataSettings.selectHomes": function mapSelectHomes() {
      let selectHomes = null;
      if (this.dataSettings.selectHomes !== null) {
        selectHomes = this.dataSettings.selectHomes.split(",");
        if (selectHomes.indexOf("35854") > -1) {
          this.selectSCOnly = true;
        }
      }
    },
  },
  beforeMount() {
    this.getProjects();
  },
};
</script>
<style lang="scss" scoped>
.project-box {
  border-radius: 15px;
  border: 1px solid #e0e0e0;
  overflow: scroll;
  max-height: calc(100vh - 455px);

  &.error {
    border-color: $red;
  }
  .head {
    border-bottom: 1px solid #e0e0e0;
    max-height: 49px;
  }
  .results-panel {
    border-left: 1px solid #e0e0e0;

    &.no-left-border {
      border-left: none;
    }
  }
  .filter {
    padding: 6px 10px 0 0;
    text-align: right;
  }
}

.input-group-addon {
  border-top-left-radius: 50%;
  border-bottom-left-radius: 50%;
  background-color: #ffffff;
  border: none;
}
.form-control {
  height: 32px;
  background-color: #ffffff;
  border: none;
}
.dropdown {
  margin-left: 5px;
  .sc-btn {
    font-weight: 500;
    border-radius: 8px !important;
    padding: 3px 10px;
    width: auto;
  }
}
.list-height {
  max-height: calc(100vh - 400px);
}
.projects {
  background-color: #ffffff;
  height: calc(100% - 110px);
  padding: 10px;
  overflow-y: auto;

  font-size: 16px;
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.31;
  letter-spacing: -0.1px;
  text-align: left;
  color: #4a4a4a;

  &-counter {
    font-weight: bold;
    color: $orange;
  }
  &-head {
    padding: 10px;
    line-height: 1.7;
    border-bottom: 1px solid #e0e0e0;
  }
  &-remove {
    font-size: 12px;
    font-weight: 500;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.64;
    letter-spacing: -0.1px;
    text-align: right;
    color: #8c8786;
  }
  .all {
    font-weight: bold;
    color: $black;
    margin-bottom: 6px;
  }
}
.project {
  cursor: pointer;
  font-size: 16px;
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.5;
  letter-spacing: -0.1px;
  text-align: left;
  color: #4a4a4a;
  padding-left: 16px;
  border-left: 1px solid #979797;

  &-group {
    cursor: pointer;
    font-size: 16px;
    font-weight: bold;
    line-height: 1.38;
    letter-spacing: -0.1px;
    color: $black;
    margin: 8px 0;
  }
  &-select {
    height: calc(100% - 48px);
    overflow-y: auto;
  }
  &:hover {
    color: $black;
  }
}
.label {
  padding: 1px 8px;
  margin: 5px;
  border-radius: 1em;
}
.dropdown {
  display: inline;
}
.input-group-text {
  background: none;
  border: none;
  border-radius: 25px;
  background-color: $white;
}
.tag {
  font-size: 14px;
  font-weight: bold;
  line-height: 1.29;
  letter-spacing: -0.1px;
  color: $black;
  border-bottom: 1px solid #e0e0e0;
  padding: 16px;
}
.disable-content {
  pointer-events: none;
  opacity: 0.5;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/view/article/create/ContentReceiver.vue